import { makeStyles } from "@material-ui/core";

const alignMap = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
};

const useRbPaginationStyles = makeStyles(() => ({
  root: (props) => ({
    display: "flex",
    justifyContent: alignMap[props.align],
  }),
}));

export default useRbPaginationStyles;
